import type { RebookingPaymentStatus } from '@/scopes/payment/domain/types'
import { Banner } from '@sunwebgroup/uds-ui/banner'
import * as React from 'react'
import { useIntl } from '@/intl'

const REBOOKING_PAYMENT_MESSAGE_KEYS = {
  fullyCovered: {
    title: 'checkout_scope_rebooking_fully_covered_title',
    description: 'checkout_scope_rebooking_fully_covered_description',
  },
  downPaymentCovered: {
    title: 'checkout_scope_rebooking_down_payment_covered_title',
    description: 'checkout_scope_rebooking_down_payment_covered_description',
  },
  partiallyCovered: {
    title: 'checkout_scope_rebooking_partially_covered_title',
    description: 'checkout_scope_rebooking_partially_covered_description',
  },
} as const

interface RebookingPaymentBannerProps {
  status: Exclude<RebookingPaymentStatus, 'notPaid'>
  amountAlreadyPaid: number | null
}

export function RebookingPaymentBanner({ status, amountAlreadyPaid }: RebookingPaymentBannerProps) {
  const intl = useIntl()
  const messageKeys = REBOOKING_PAYMENT_MESSAGE_KEYS[status]

  return (
    <Banner color="informative" size="M" hasIcon contentIsCentered>
      <Banner.TextsWrapper>
        <Banner.Text>{intl.formatMessage({ id: messageKeys.title })}</Banner.Text>
        <Banner.SupportingText>
          {intl.formatMessage(
            { id: messageKeys.description },
            amountAlreadyPaid === null ? undefined : { amount: intl.formatCurrency(amountAlreadyPaid) },
          )}
        </Banner.SupportingText>
      </Banner.TextsWrapper>
    </Banner>
  )
}
